// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","570":"29107295","834":"94726e6d","869":"styles"}[chunkId] + "-" + {"293":"6aca606f8117c595480c","570":"537c6a369ad8c5404053","834":"45e1dbe99d237fa6a7db","869":"d115282a6a4456c9cefc"}[chunkId] + ".js";
};